module.exports = __webpack_public_path__ + "img/sayings@2x.7b04046.webp";